import { atom } from "jotai/index";
import { atomWithStorage } from "jotai/utils";

import { SysDomainRegularDto, UserResponseRegularDto } from "@/shared/api";

export const appCurrentRoom = atom<SysDomainRegularDto | null | undefined>(undefined);
export const meStore = atom<UserResponseRegularDto | undefined>(undefined);
export const headerTitle = atom<string>("");
export const isDarkMode = atomWithStorage<boolean>("darkMode", false);
